<template>
  <div class="project-base-info">
    <el-card class="box-card">
      <div slot="header" class="clearfix title">
        <i class="iconfont eltte-doc"></i>
        <span>基本信息</span>
      </div>
      <div class="card-body">
        <el-form-item label="项目名称：" prop="name">
          <el-input v-model="baseForm.name" placeholder="请输入项目名称" :disabled='disabled'></el-input>
        </el-form-item>
        <el-row type="flex" :gutter="20">
          <el-col :span="8">
            <el-form-item label="项目编号：" prop="code">
              <el-input v-model="baseForm.code" placeholder="请输入项目编号" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="市场专员：" prop="empName" :span="8">
              <el-input v-model="baseForm.empName" placeholder="请输入专员名称" :disabled='true'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：" prop="linkPhone" :span="8">
              <el-input v-model="baseForm.linkPhone" placeholder="请输入电话号码" :disabled='true'></el-input>
            </el-form-item>
          </el-col>

        </el-row>
         <!-- <el-row type="flex">
           <el-form-item label="审批人：" prop="approverId">
            <el-select v-model="baseForm.approverId" filterable placeholder="请选择" :disabled='disabled' @change="selectApprover">
              <el-option v-for="(item,index) in approvers" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> 
        </el-row>  -->

      </div>
    </el-card>

  </div>

</template>

<script>
import * as roleApi from '../../api/roleAPI'
export default {
  components: {

  },
  props: {
    baseForm: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      approvers: [],


    };
  },
  computed: {

  },
  watch: {

  },
  async created() {
    this.userInfo = await this.$store.getters.getUserInfo
    this.baseForm.empId = this.userInfo.id
    this.$set(this.baseForm, 'empName', this.userInfo.username)
    this.$set(this.baseForm, 'linkPhone', this.userInfo.mobile)
    let res = await roleApi.findUserByRoleId(1)
    if (res.flag) {
      this.approvers = res.data
    }

  },
  mounted() {

  },
  methods: {
    selectApprover(id) {
      console.log('selectApprover', id);
      this.$set(this.baseForm, 'approverName', this.approvers.find(a => a.id == id).username)
    }
  },
};
</script>

<style  lang="less" >
.project-base-info {
  .el-card {
    box-shadow: none !important;
    border: none !important;
    border-radius: 10px;
    padding: 0 40px;
    .el-card__header {
      padding: 10px 0px 20px 0px;
      .title {
        > i {
          font-size: 20px;
          color: #346aff;
          font-weight: 400;
        }
      }
    }
    .el-card__body {
      padding: 20px 0px 0px 0px;
      .el-row--flex {
        .el-form-item + .el-form-item {
          margin-left: 40px;
        }
        .el-input__inner {
          // width: 200px;
          position: relative;
        }
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .box-card{
     //width: 800px;
    }
   
  }
}
</style>

